<template>
  <div class="row">
    <div class="col-md-12">
      <div class="pull-left">
        <router-link class="btn btn-orange" to="/marketing/campaigns"><i class="ti-arrow-left"></i> {{$t('general.back')}}</router-link>
      </div>
      <p class="clearfix"></p>
      <campaign-form @on-submit="onCampaignSubmit"></campaign-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import CampaignForm from './CampaignForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      CampaignForm
    },
    data () {
      return {
        campaignModel: {},
        campaign: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onCampaignSubmit (model, isValid) {
        this.campaignModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Campaigns/CampaignEdit.vue